// Tema claro / oscuro / automático.
//
// ORIGEN (policies/architecture.md §9): portado de `Luma/luma-ui/src/lib/theme.ts`. El modo se
// resuelve a un atributo `data-theme` en <html> — no a una media query — porque la política exige
// modo claro y modo oscuro elegantes *elegibles*, y una media query sola no deja elegir.
//
// La clave de storage tiene que ser la misma que usa el bootstrap anti-flash de `index.html`: si
// se separan, la app pinta un tema y el arranque pinta el otro.
export type ThemeMode = 'light' | 'dark' | 'auto';
export type ResolvedTheme = 'light' | 'dark';

const STORAGE_KEY = 'nexa-theme';

function systemPrefersDark(): boolean {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function readThemeMode(): ThemeMode {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'light' || stored === 'dark' || stored === 'auto') return stored;
  } catch {
    // Storage bloqueado (modo privado, política del navegador): el tema no es un dato crítico,
    // se cae al automático en vez de romper el arranque.
  }
  return 'auto';
}

export function resolveTheme(mode: ThemeMode): ResolvedTheme {
  if (mode === 'auto') return systemPrefersDark() ? 'dark' : 'light';
  return mode;
}

/** Estampa el tema resuelto en <html>. Es lo único que leen las variantes `dark:` de Tailwind. */
export function applyThemeMode(mode: ThemeMode): ResolvedTheme {
  const resolved = resolveTheme(mode);
  const root = document.documentElement;
  root.setAttribute('data-theme', resolved);
  root.style.colorScheme = resolved;
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    // Ídem: preferencia no persistida, pero la sesión en curso sí respeta la elección.
  }
  return resolved;
}
